(function() {
    'use strict';

    angular
        .module('anrescowebApp')
        .controller('OrderDetailsController', OrderDetailsController);

    OrderDetailsController.$inject = ['$timeout', 'CustomerOrderPdfService','$scope', '$rootScope', '$stateParams', '$state', 'CustomerOrder',
         'CustomerOrderDetails', 'Sample', 'Customer','CustomerByUser','SampleAttach','SampleAttachDownload','OrderPicture', 'OrderAttach', 'OrderAttachDownload', 'SampleCoaPdfService', 'DownloadUtil'];

    function OrderDetailsController ($timeout, CustomerOrderPdfService, $scope, $rootScope, $stateParams, $state, CustomerOrder,
        CustomerOrderDetails, Sample, Customer, CustomerByUser, SampleAttach, SampleAttachDownload, OrderPicture, OrderAttach, OrderAttachDownload, SampleCoaPdfService, DownloadUtil) {

            var vm = this;

            vm.idOfSelectedSample = null;
            vm.numOfSelectedSamplePictures = 0;
            vm.getAttachmentsLoader = false;
            vm.isComplianceOrder = false;
            vm.orderIsCompleted = false;
            vm.showReports = true;

            vm.due_date_info = {
                same_for_all: false,
                due_date: null
            }

            vm.customerOrder = CustomerOrder.get({id : $scope.toStateParams.orderId},
                function(data) {
                    if (data.state === 'CANCELLED' || data.qbench_state === 'CANCELLED') {
                        $state.go('orders', {}, {location: 'replace'});
                        return;
                    }
                    var type_of_business = data.customer.businessType.name.toLowerCase();

                    afterCustomerOrderGet();

                    if (type_of_business.includes('food')) {
                        vm.consolidated_business_type = 'food';
                    }
                    else {
                        vm.consolidated_business_type = 'cannabis';
                    }

                    parseDueDates(data);
                    checkLotNumbers(data);

                    return data
                },
                function(e) {
                    if (e && e.status === 404) {
                        $state.go('orders', {}, {location: 'replace'});
                        return;
                    }
                    console.log(e);
                }
            );

            function parseDueDates(order) {
                var current_due_date = null;
                var sample = null;
                var tests = null;
                var test = null;

                for(var sample_index = 0; sample_index < order.samples.length; sample_index++) {
                    sample = order.samples[sample_index];
                    tests = order.samples[sample_index].sampleTests;

                    for(var test_index = 0; test_index < tests.length; test_index++) {
                        test = tests[test_index];
                        if(current_due_date == null) current_due_date = test.estimatedCompleteDate;

                        if(test.estimatedCompleteDate != current_due_date) {
                            vm.due_date_info = {
                                same_for_all: false,
                                due_date: null
                            }

                            return
                        }
                    }
                }

                vm.due_date_info = {
                    same_for_all: true,
                    due_date: current_due_date
                }
            }

            function checkLotNumbers(order) {
                vm.hasLotNumbers = false;
                for(var i = 0; i < order.samples.length; i++) {
                    if(order.samples[i].lotBatchNumber) {
                        vm.hasLotNumbers = true;
                        return;
                    }
                }
            }

            function isLabelAttachment(attachment) {
                if (!attachment) {
                    return false;
                }

                if (attachment.type === 'SAMPLE_LABEL_ATTACHMENT') {
                    return true;
                }

                var fileName = ((attachment.file_name || '') + '').toLowerCase();
                return /(^labels?(?:\b|[_-])|[_\s-]labels?\b)/.test(fileName);
            }

            function afterCustomerOrderGet() {
                setOrderProgress()

                vm.isComplianceOrder = vm.customerOrder.order_type.toLowerCase().includes('compliance');
                vm.orderIsCompleted = vm.customerOrder.state == 'COMPLETED';

                // info hover that will list analyses requested with that consulting assay
                var isRDOrder = vm.customerOrder.order_type && vm.customerOrder.order_type.toUpperCase() === 'RD';
                vm.customerOrder.samples.forEach( function(sample) {
                    if (!sample.canSeeReport && !isRDOrder) {
                        vm.showReports = false;
                    }
                    sample.sampleTests.forEach( function(test) {
                        if (test.assay.portalIdentifier == 'CONSULTING') {
                            test.comments = test.comments.slice(18).split('\n');
                        }
                    });
                });
                getPictures();
                $('#orderNo').html('Order No. ' + $scope.toStateParams.orderId);

            }
            
            function setTabsVisibility() {
                $scope.invoiceBtnToggle = false;
                CustomerByUser.get({}, function(customer) {
                    $scope.invoiceBtnToggle = customer.billingAccess === true;
                });
            }

            $rootScope.getOrderAttachments = function (order) {
                var id = $scope.toStateParams.orderId;
                vm.getAttachmentsLoader = true;
                vm.idOfSelectedOrder = id;

                if(order.attachments != null){
                    vm.getAttachmentsLoader = false;
                    return;
                }

                OrderAttach.query({id: id}, onSuccess, onError);
                function onSuccess(data, headers) {
                    vm.getAttachmentsLoader = false;
                    order.attachments = data;
                }

                function onError(error) {
                    console.log(error.data.message)
                    // AlertService.error(error.data.message);
                }
            }

            $rootScope.downloadOrderAttachment = function (id_hash,order) {
                OrderAttachDownload.get({id: id_hash}, onSuccess, onError);

                function onSuccess(data, headers) {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";

                    var fileURL = window.URL.createObjectURL(data.data);
                    a.href = fileURL;
                    a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
                    a.click();
                    order.select = "";
                }

                function onError(error) {

                }
            }

            function setOrderProgress() {
                vm.progress = 1;

                if(vm.customerOrder.state == "CREATED"){
                    vm.progress = 1
                }
                else if(vm.customerOrder.state == "SAMPLES_RECEIVED"){
                    vm.progress = 2;
                }
                else if(vm.customerOrder.state == "PRELIMINARY_RESULTS"){
                    vm.progress = 3
                }
                else if(vm.customerOrder.state == "COMPLETED"){
                    vm.progress = 4
                }
                else if(vm.customerOrder.state == "INVOICED"){
                    vm.progress = 5
                }
            }


            vm.downloadOrderPdf = downloadOrderPdf;

            //show loading image first, when order is loaded show cached images,finally show all images from server

                if (vm.customerOrder.cachedPictures != null && vm.customerOrder.cachedPictures.length>0) {
                    setPictures(vm.customerOrder.cachedPictures )
                }
                else {
                    var defaultPicture = new Array();
                    defaultPicture.push({id: 0, name: "Empty Sample", url: "content/images/loading.gif"});
                    setPictures(defaultPicture )
                }

            function getPictures () {
                var id = vm.customerOrder.id;

               OrderPicture.query({id: id}, onSuccess, onError);

                function onSuccess(data, headers) {
                      setPictures(data);
                }

                function onError(error) {
                    console.log(error.data.message)
                    //AlertService.error(error.data.message);
                }
            }

            function setPictures(pictures) {

                vm.pictures = pictures;

                vm.numOfSelectedSamplePictures = vm.pictures.length;

                if( vm.numOfSelectedSamplePictures > 1){
                    vm.show = 1;
                }
                else {

                }
                if( vm.numOfSelectedSamplePictures < 1){
                    for(var i = 0; i <(4 - vm.numOfSelectedSamplePictures ); i++ ){
                        vm.pictures.push({id: i, name: "Empty Sample", url: "content/images/no_image_available-small.png"});
                    }
                }
            }

            $timeout(function (){
                angular.element('.form-group:eq(1)>input').focus();
            });


            // function save () {
            //     vm.isSaving = true;
            //     if (vm.customerOrder.id !== null) {
            //         CustomerOrder.update(vm.customerOrder, onSaveSuccess, onSaveError);
            //     } else {
            //         CustomerOrder.save(vm.customerOrder, onSaveSuccess, onSaveError);
            //     }

            // }

            // function onSaveError () {
            //     vm.isSaving = false;
            // }

            // vm.datePickerOpenStatus.dateReceived = false;
            // vm.datePickerOpenStatus.checkoutDate = false;

            // function openCalendar (date) {
            //     vm.datePickerOpenStatus[date] = true;
            // }


            $scope.getAttachments = function (sample, id) {
                vm.getAttachmentsLoader = true;
                vm.idOfSelectedSample = id;

                if(sample.attachments != null){
                    vm.getAttachmentsLoader = false;
                    return;
                }

                SampleAttach.query({id: id}, onSuccess, onError);
                function onSuccess(data, headers) {
                    var processed_attachments = [];

                    vm.getAttachmentsLoader = false;

                    if(!vm.consolidated_business_type.includes('cannabis')) {
						data.forEach( function(attachment) {
							if(!isLabelAttachment(attachment)) {
								processed_attachments.push(attachment)
							}
						})
                    }
                    else if (!vm.isComplianceOrder) {
                        processed_attachments = data;
                    } else {
                        data.forEach(function(attachment) {
                            if (vm.orderIsCompleted && sample.canSeeReport) {
                                processed_attachments.push(attachment);
                            }
                            else {
                                if (!attachment.file_name.toLowerCase().includes('coa')) {
                                    processed_attachments.push(attachment);
                                }
                            }
                        });
                    }

                    // Sort Order of Sample Downloads 
                    processed_attachments.sort(function(a, b) {
                        var getPriority = function(filename) {
                            var name = filename.toLowerCase();
                            
                            // 1. Consolidated COA
                            if (name.includes('consolidated') && name.includes('coa')) return 1;
                            
                            // 2. Test COAs
                            if (name.includes('coa') && !name.includes('consolidated') && !name.includes('summary')) return 2;
                            
                            // 3. COA Summary 
                            if (name.includes('coa') && name.includes('summary')) return 3;
                            
                            // 4. QR Code
                            if (name.includes('qr') || name.includes('qr_code') || name.includes('qrcode')) return 4;
                            
                            // 5. Photos 
                            if (name.match(/\.(jpg|jpeg|png|gif|bmp|webp|tiff)$/)) return 5;
                            
                            // 6. Other attachments
                            return 6;
                        };
                        
                        return getPriority(a.file_name) - getPriority(b.file_name);
                    });
                    

                    sample.attachments = processed_attachments;
                }

                
                function onError(error) {
                    console.log(error.data.message)
                }
            }

            $scope.downloadAttachment = function (id_hash, sample) {
                if(id_hash && id_hash != 'coa'){
                    SampleAttachDownload.get({id: id_hash}, onSuccess, onError);

                    function onSuccess(data, headers) {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        var fileURL = window.URL.createObjectURL(data.data);
                        a.href = fileURL;
                        a.download = DownloadUtil.getFilenameFromContentDisposition(headers('content-disposition'));
                        a.click();
                    }
                    function onError(error) {
                        console.log(error);
                    }
                }
                else {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    SampleCoaPdfService.downloadPdf(sample.hash).then(function(result) {
                        var file = new Blob([result.data], {
                            type: 'application/pdf'
                        });

                        a.href = window.URL.createObjectURL(file);
                        a.download = sample.id + '_COA_Summary.pdf';
                        a.click();
                    });
                }
                sample.select = "";
            }


            function downloadOrderPdf () {
                var id = $scope.toStateParams.orderId

                if (vm.customerOrder.orderType === 'COMPLIANCE') {
                 var fileName = id + " Compliance Submission Form.pdf";
                } else {
                 var fileName = id + " R&D Submission Form.pdf";
                }

                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                CustomerOrderPdfService.downloadPdf(id).then(function (result) {
                    var file = new Blob([result.data], {type: 'application/pdf'});
                    var fileURL = window.URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = fileName;
                    a.click();
                }).catch(function(error){
                    if(error.status === 401){
                        //clear();
                    }
                });
            }

            angular.element(document).ready(function() {
                setTabsVisibility(); 

                $(".status-wizard-step a").each(function(index, element) {
                    index++;
                    $(this).attr("id", "open-tooltip-"+index);
                    $("#open-tooltip-"+index).click(function(){
                        $(".status-wizard-step a").not(this).removeClass('open');
                        $(this).toggleClass("open");
                        return this;
                    });
                });

                $(".status-wizard-step.active > .status-wizard-dot span" ).remove();
            });

    }
})();
